import FooterScrolling from './FooterScrolling';

export default FooterScrolling;
